<template>
  <v-flex data-qa="closesavingsaccount-flex-k9u86l">
    <v-layout row wrap data-qa="closesavingsaccount-layout-a7b2a">
      <v-layout wrap class="ml-2" data-qa="closesavingsaccount-layout-sbvz7">
        <v-flex xs12 sm12 md12 lg12 xl12
          :style="{ background: dashboardGradient }"
         data-qa="closesavingsaccount-flex-j7nod">
          <v-container class="pa-6 pl-12" data-qa="closesavingsaccount-container-ojl39">
            <v-flex xs12 sm12 md12 lg12 xl12 data-qa="closesavingsaccount-flex-4gwa3g">
              <v-row no-gutters data-qa="closesavingsaccount-row-3117mq">
                <v-layout row wrap class="pb-2" data-qa="closesavingsaccount-layout-bp6p9">
                  <inline-svg
                    class="mt-2"
                    :src="getNavigationIcon(accountType)"
                    width="50"
                    height="50"
                    aria-label="Navigation Icon"
                  ></inline-svg>
                  <font
                    class="display-1 font-weight-thin white--text pt-4 pl-2"
                    >{{ getAccountTypeLabel(accountType) }}</font
                  >
                </v-layout>
              </v-row>
              <v-row class="pl-4" data-qa="closesavingsaccount-row-ton0en">
                <v-layout wrap data-qa="closesavingsaccount-layout-e2i6rq">
                  <v-flex lg9 xl9 data-qa="closesavingsaccount-flex-0qichk">
                    <v-layout row wrap data-qa="closesavingsaccount-layout-l2xsya">
                      <v-flex xs12 sm6 md6 lg5 xl4 class="px-1" data-qa="closesavingsaccount-flex-xe9by4">
                        <font class="subheading font-weight-medium white--text">{{
                          $t("accountDetails.accountNumber")
                        }}</font>
                        <br data-qa="closesavingsaccount-br-lrn1tg">
                        <font class="text-h5 font-weight-bold white--text">{{
                          accountNumber
                        }}</font>
                      </v-flex>
                      <v-flex xs12 sm6 md6 lg4 xl4 class="px-1" data-qa="closesavingsaccount-flex-oc1v2j">
                        <font class="subheading font-weight-medium white--text">{{
                          isFixedRateCashIsaAccount
                            ? $t("accountDetails.availableBalance")
                            : isNoticeCashIsaAccount ? $t("accountDetails.availableBalance")
                            : $t("accountDetails.accountBalance")
                        }}</font>
                        <br data-qa="closesavingsaccount-br-wxtcwf">
                        <font class="text-h5 font-weight-bold white--text">{{
                          $formatter.currency.format(balance, currency)
                        }}</font>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-row>
            </v-flex>
          </v-container>
        </v-flex>
        <v-flex class="text-left mt-2 mb-2" data-qa="closesavingsaccount-flex-xbu5ye">
          <v-btn
            text
            :color="primaryColor"
            class="text-capitalize py-2 px-4"
            @click="viewDetails()"
           data-qa="closesavingsaccount-btn-8oui">
            <v-icon left class="material-symbols-outlined" size="18px" data-qa="closesavingsaccount-icon-h0l14">arrow_left_alt</v-icon>
            {{$t('accountDetails.viewDetails')}}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-layout>

    <!-- Close Account Screen -->
    <v-flex class="mx-1" data-qa="closesavingsaccount-flex-rfty2o">
      <!-- Select Pay Away account -->
      <v-flex data-qa="closesavingsaccount-flex-1qtbzs">
        <v-card class="pa-6" width="830" elevation="0" data-qa="closesavingsaccount-card-6wgip">
          <font class="title font-weight-bold">
            {{ this.enableConfirm ? $t("closeAccount.confirmAccClose") : $t("closeAccount.title") }}
          </font>
          <v-flex v-if="displaySelectAccount" class="mx-5 my-5" data-qa="closesavingsaccount-flex-nfj7vo">
            <font class="body-1 font-weight-bold pb-2">
              {{ this.enableConfirm ? $t("closeAccount.creditPayaway") : $t("closeAccount.selectPayaway") }}
            </font>
            <v-flex class="mt-6 mb-4" data-qa="closesavingsaccount-flex-bpr1f">
              <v-tabs
                v-if="!enableConfirm"
                v-model="selectedAccountType"
                @change="changeAccountType"
                :color="primaryColor"
               data-qa="closesavingsaccount-tabs-u0o909">
                <v-tab class="text-capitalize font-weight-bold" data-qa="closesavingsaccount-tab-q59q0d">
                  {{ $t("termDepositActions.listAC.internalButtonLabel") }}
                </v-tab>
                <v-tab class="text-capitalize font-weight-bold" data-qa="closesavingsaccount-tab-ewl0tn">
                  {{ $t("termDepositActions.listAC.externalButtonLabel") }}
                </v-tab>
              </v-tabs>
            </v-flex>
            <v-tabs-items v-model="selectedAccountType" data-qa="closesavingsaccount-tabs-items-o4gr99">
              <v-tab-item v-for="(n, i) in 2" :key="n" :data-qa="`closesavingsaccount-tab-item-1j0v8-${i}`">
                <v-select
                  v-model="selectedPayAwayAcc"
                  :label="enableConfirm ? '' : $t('closeAccount.selectPayawayHint')"
                  :disabled="enableConfirm"
                  :items="selectedAccountType === 0 ? sameAccountsNOCR : otherAccounts"
                  :color="primaryColor"
                  @change="setPayAwayAC"
                  :hint="selectedPayAwayHint"
                  persistent-hint
                  :data-qa="`closesavingsaccount-select-f9kdhj-${i}`">
                  <template v-slot:item="data">
                    <v-list-item-content :data-qa="`closesavingsaccount-list-item-content-5e74ld-${i}`">
                      {{ data.item.primaryLine }}
                      <v-list-item-subtitle :data-qa="`closesavingsaccount-list-item-subtitle-bgl5w8-${i}`"
                        v-text="data.item.secondaryLine"
                      />
                      <v-divider :data-qa="`closesavingsaccount-divider-1ed6e-${i}`"  />
                    </v-list-item-content>
                  </template>
                </v-select>
              </v-tab-item>
            </v-tabs-items>
            <v-flex v-if="showCloseAccountReason" class="mt-6 mb-4" data-qa="closesavingsaccount-flex-4ev7en">
              <v-select data-qa="closesavingsaccount-select-c3ymj"
                v-model="selectedReasonForClosure"
                :label="enableConfirm ? '' : $t('closeAccount.selectReasonForClosure')"
                :disabled="enableConfirm"
                :items="reasonForClosureList"
                :color="primaryColor"
                @change="setPayAwayAC"
                return-object
              />
            </v-flex>
          </v-flex>
          <v-row class="justify-start" data-qa="closesavingsaccount-row-zelxir">
            <v-btn
              v-if="enableConfirm"
              @click="goBack()"
              class="text-none py-2 px-4"
              :color="primaryColor"
              outlined
             data-qa="closesavingsaccount-btn-bsheyp">
              <v-icon left size="18px" class="material-symbols-outlined" data-qa="closesavingsaccount-icon-vblowb">arrow_left_alt</v-icon>
              {{ $t("common.back") }}
            </v-btn>
            <v-btn
              v-if="!enableConfirm"
              @click="onProceed()"
              :color="primaryColor"
              :disabled="enableNext"
              style="margin-left: 32px;"
              class="text-capitalize font-weight-bold white--text py-2 px-4"
               data-qa="closesavingsaccount-btn-dtcbl">{{ $t("closeAccount.btnProceed") }}</v-btn
            >
            <v-btn
              v-if="enableConfirm"
              @click="onNext()"
              :color="primaryColor"
              style="margin-left: 24px;"
              class="text-capitalize font-weight-bold white--text py-2 px-4"
               data-qa="closesavingsaccount-btn-8u2bu9">{{ $t("closeAccount.btnConfirm") }}</v-btn
            >
          </v-row>
        </v-card>
      </v-flex>
    </v-flex>
    <!-- OTP Component -->
    <Modal
      v-if="otpConfig.enabled"
      :config="otpConfig"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="closesavingsaccount-span-tbl7">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
    <!-- Amend Confirm Screen -->
    <Modal
      v-if="confirmFormData.showConfimModal"
      :config="confirmFormData.action === 'success' ? modalConfig.closeSavingsSuccess : modalConfig.closeSavingsFail"
      @btn2Action="returnToDashboard"
      @btn1Action="routeToAccountDetails"
    >
      <span v-if="confirmFormData.action === 'success'" slot="modalContent" class="font-weight-bold" data-qa="closesavingsaccount-span-3ek35w">
        {{ $t("closeAccount.successMessage") }} {{ confirmFormData.accountDetails.accountId }} {{ $t("closeAccount.successsMessage") }}
      </span>
      <span v-if="confirmFormData.action === 'fail' && confirmFormData.causes" slot="modalContent" class="font-weight-bold" data-qa="closesavingsaccount-span-0v6k">
        <v-flex data-qa="closesavingsaccount-flex-2otpsm">
          {{ $t("closeAccount.failureMessage") }}
        </v-flex>
      </span>
    </Modal>
  </v-flex>
</template>

<script>
import _ from 'lodash'
import event from '@/util/event'
import preload from '@/util/preload'
import commonService from '@/service/commonService.js'
import OtpInput from '@/components/common/OtpInput.vue'
import { formatPrimaryLine, formatSecondaryLine, formatSelectedAccount, formatSelectedHint } from '../../../util/accountUtil'

export default {
  name: 'CloseSavingsAccount',
  components: {
    OtpInput,
    Modal: () => import('@/components/common/Modal.vue')
  },
  data () {
    return {
      accountType: '',
      accountNumber: '',
      currency: '',
      balance: 0,
      depositAmt: 0,
      enableConfirm: false,
      isFixedRateCashIsaAccount: false,
      isInstantCashIsaAccount: false,
      isNoticeCashIsaAccount: false,
      isCashIsaAccount: ['TXNA', 'TXFR', 'TXEA'].includes(this.accountType),
      excludeAccountStatus: ['DORMANT', 'DEACTIVATED', 'INACTIVE', 'BLOCKED', 'STOPPED', 'CLOSED'],
      excludeARIStatus: ['REFREPOST', 'REFREPOSTENQ', 'CREDIT', 'DEBIT', 'REFREDR', 'REFRECR', 'DEBITCREDIT', 'ACCSTOPENQ', 'REFREPOSTNOREFENQ', 'ACCSTOPENQWITHREF'],
      excludeARIStatusTXFR: ['REFREPOST', 'REFREPOSTENQ', 'CREDIT', 'REFREDR', 'REFRECR', 'DEBITCREDIT', 'ACCSTOPENQ', 'REFREPOSTNOREFENQ', 'ACCSTOPENQWITHREF'],
      showTransferOut: false,
      displaySelectAccount: false,
      confirmAccClose: false,
      onConfirm: false,
      enableNext: true,
      closeAccAPIFailed: false,
      selectedAccountType: 0,
      selectedPayAwayAcc: '',
      selectedReasonForClosure: '',
      defaultReasonForClosure: '000',
      accountDetails: [],
      sameAccountsNOCR: [],
      otherAccounts: [],
      reasonForClosureList: [],
      allowedPayawayAccountTypeForSavingsClosure: this.$appSettings.defaultConfigurations.savingsAccountClosure.allowedPayawayAccountType,
      allowedPayawayAccountTypeForCurrentClosure: this.$appSettings.defaultConfigurations.currentAccountClosure.allowedPayawayAccountType,
      allowedPayawayAccTypeForFixedRateClosure: this.$appSettings.defaultConfigurations.fixedRateAccClosure.allowedPayawayAccountType,
      allowedPayawayAccTypeForInstCashIsaClosure: this.$appSettings.defaultConfigurations.instantCashAccClosure.allowedPayawayAccountType,
      enableOTP: this.$appSettings.defaultConfigurations.instantCashAccClosure.enableOTPForInstCashAccClosure,
      enableOTPForSavingsAccountClosure: this.$appSettings.defaultConfigurations.savingsAccountClosure.enableOTPForSavingsAccountClosure,
      enableOTPForCurrentAccClosure: this.$appSettings.defaultConfigurations.currentAccountClosure.enableOTPForCurrentAccClosure,
      enableOTPForFixedRateAccClosure: this.$appSettings.defaultConfigurations.fixedRateAccClosure.enableOTPForFixedRateAccClosure,
      nominatedAccountsConfig: this.$appSettings.defaultConfigurations.nominatedAccounts.enableNominatedAccountFeatures,
      enableTransferOutInfo: this.$appSettings.defaultConfigurations.enableTransferOutInfo,
      validReasons: this.$appSettings.validCloseAccountReasons,
      showCloseAccountReason: this.$appSettings.showCloseAccountReason,
      showOTPScreen: false,
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      otpConfig: {
        enabled: false,
        persistent: true,
        enableSave: true,
        close: true,
        saveButton: '',
        outlinedSaveBtn: false,
        title: this.$t('otp.toolBarTitle'),
        width: 400
      },
      errors: [],
      modalConfig: {
        closeSavingsSuccess: {
          enabled: true,
          title: this.$t('closeAccount.closeAccSuccess'),
          persistent: true,
          btn1Label: this.$t('closeAccount.viewAccDetailsBtnLabel'),
          btn2Label: this.$t('common.goToDashboardBtnLabel'),
          width: 500
        },
        closeSavingsFail: {
          enabled: true,
          title: this.$t('closeAccount.closeAccFailed'),
          persistent: true,
          btn1Label: this.$t('closeAccount.viewAccDetailsBtnLabel'),
          btn2Label: this.$t('common.goToDashboardBtnLabel'),
          width: 500
        }
      },
      confirmFormData: {
        showConfimModal: false
      },
      serviceNotAvailableStatusList: [401, 500],
      allowInactiveAccountTransactionalOperations: this.$appSettings.defaultConfigurations.allowInactiveAccountTransactionalOperations
    }
  },
  async created () {
    if (this.$route.params.accountType !== undefined && this.$route.params.accountNumber !== undefined) {
      this.accountType = this.$route.params.accountType
      this.accountNumber = this.$route.params.accountNumber
      this.balance = this.$route.params.balance
      this.currency = this.$route.params.currency
      this.depositAmt = this.$route.params.depositAmt
    } else {
      this.$router.push('/home')
    }
    await this.getAccountDetails(this.accountNumber)
    await this.getReasonForClosure()
    event.$on('verifyOTP', args => {
      this.otpConfig.enabled = true
    })
    event.$on('IS_OTP_VALID', (val) => {
      if (val && this.otpConfig.enabled) {
        this.otpConfig.enabled = false
        if (this.isFixedRateCashIsaAccount) {
          this.updateARI()
        } else {
          this.closeSavingsAcc()
        }
      } else {
        this.otpConfig.enableSave = true
        this.goToTransactions()
      }
    })
  },
  computed: {
    resource () {
      return {
        apiReqFail: this.$t('closeAccount.apiReqFail')
      }
    },
    selectedPayAwayObj () {
      if (this.selectedAccountType === 0) {
        return this.sameAccountsNOCR.find(acc => acc.accountId === this.selectedPayAwayAcc)
      }
      return this.otherAccounts.find(acc => acc.value === this.selectedPayAwayAcc)
    },
    selectedPayAwayHint () {
      if (!this.selectedPayAwayObj) return ''
      if (this.selectedAccountType === 0) {
        return formatSelectedHint(this.selectedPayAwayObj)
      }
      return this.selectedPayAwayObj.secondaryLine
    }
  },
  methods: {
    onOtpModalClose () {
      this.showOTPScreen = false
      this.otpConfig.enabled = false
      this.otpConfig.enableSave = true
    },
    async returnToDashboard () {
      await preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
      this.$router.push('/home')
    },
    async routeToAccountDetails () {
      this.$router.push({ name: 'AccountDetails', params: { product: this.accountDetails, balance: this.balance, accountId: this.accountNumber, accountType: this.accountType, navToTab: 1 } }).catch(() => {})
    },
    getCauses (data) {
      this.errors = data.causes
    },
    async getAccountDetails (accountNumber) {
      this.displaySelectAccount = true
      const response = accountNumber ? await commonService.getAccountDetails(accountNumber) : ''
      if (response && !response.causes) {
        this.accountDetails = response
        this.accountNumber = this.accountDetails.accountId
        // Same bank
        await this.getAccountsWithBalance()
        // Other Bank
        await this.getBeneficiaries()
      }
      await this.setAccountDetails()
    },
    setAccountDetails () {
      this.isFixedRateCashIsaAccount = this.accountType === 'TXFR'
      this.isInstantCashIsaAccount = this.accountType === 'TXEA'
      this.isNoticeCashIsaAccount = this.accountType === 'TXNA'
    },
    async updateARI () {
      let body = ''
      if (this.closeAccAPIFailed) {
        body = {
          accountAdditionalDetails: {
            postingRestriction: 'DEBIT'
          }
        }
      } else {
        body = {
          accountAdditionalDetails: {
            postingRestriction: 'NONE'
          }
        }
      }
      const response = await commonService.updateARI(this.accountNumber, body)
      if (this.isServiceUnavailable(response)) {
        this.dispatchError(this.resource.apiReqFail)
        return
      }
      if (response && !response.causes && !this.closeAccAPIFailed) {
        await this.closeSavingsAcc()
      }
    },
    async getReasonForClosure () {
      const response = await commonService.getGenericCodes({ codeReferences: [{ reference: '275' }] })
      const reasonsListArray = response?.aggregateCodes?.[0]?.codes ?? []
      this.reasonForClosureList = reasonsListArray
        .map(reason => ({
          text: reason.codeDescription,
          value: reason.codeReference
        }))
        .filter(reason => this.validReasons.includes(reason.value))
        .sort((a, b) => a.text.localeCompare(b.text))
    },
    async closeSavingsAcc () {
      const body = this.getCloseSavingsAccBody()
      const response = await commonService.closeSavingsAccount(this.accountNumber, body)
      if (this.isServiceUnavailable(response)) {
        this.dispatchError(this.resource.apiReqFail)
        return
      }
      if (response) {
        if (response.causes && this.isFixedRateCashIsaAccount) {
          this.closeAccAPIFailed = true
          await this.updateARI()
          await this.getFormData(response)
        } else {
          await preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
          await this.getFormData(response)
        }
      }
    },
    getCloseSavingsAccBody () {
      return {
        reasonForClosure: this.showCloseAccountReason ? this.selectedReasonForClosure.value : this.defaultReasonForClosure,
        payawayBeneficiaryId: this.selectedAccountType === 0
          ? ''
          : this.otherAccounts.find(acc => acc.value === this.selectedPayAwayAcc).beneficiaryId,
        payawayAccountId: this.selectedAccountType === 0 ? this.selectedPayAwayAcc : ''
      }
    },
    async getFormData (respData) {
      this.confirmFormData = { showConfimModal: false }
      if (respData && !respData.causes) {
        await this.getBalance(respData?.accountId)
        this.confirmFormData.showConfimModal = true
        this.confirmFormData.action = 'success'
        this.confirmFormData.balance = this.balance
        this.confirmFormData.accountDetails = this.accountDetails
      } else {
        this.confirmFormData.action = 'fail'
        this.confirmFormData.showConfimModal = true
        this.confirmFormData.balance = this.balance
        this.confirmFormData.status = respData.data.status
        this.confirmFormData.accountDetails = this.accountDetails
        const uniqueCode = [...new Map(respData.causes.map((item) => [item.code, item])).values()]
        this.confirmFormData.causes = uniqueCode
        this.getCauses(this.confirmFormData)
      }
      this.modalConfig.closeSavingsSuccess.enabled = true
      this.modalConfig.closeSavingsFail.enabled = true
    },
    async getBalance (accountId) {
      if (this.isCashIsaAccount) {
        const resp = await commonService.getNoticeAccountBalances(accountId)
        this.balance = resp?.balanceInformation?.availableBalance
      } else {
        const resp = await commonService.getAccountBalances(accountId)
        if (resp && resp.balances) {
          this.balance = _.filter(resp.balances, { balanceType: 'INTERIMCLEARED' })[0]?.amount?.amount
        }
      }
    },
    getAccountTypeLabel (accType) {
      let label
      switch (accType) {
        case 'SVGS':
          label = this.$t('accountDetails.savingAccountsLabel')
          break
        case 'CACC':
          label = this.$t('accountDetails.currentAccountsLabel')
          break
        default:
          label = this.$t('accountDetails.taxAccountsLabel')
          break
      }
      return label
    },
    getNavigationIcon (accType) {
      let returnType
      switch (accType) {
        case 'SVGS':
          returnType = this.getSvgIconSrc('Savings_1')
          break
        default:
          returnType = this.getSvgIconSrc('Savings_1')
          break
      }
      return returnType
    },
    viewDetails () {
      this.$router.push({ name: 'AccountDetails', params: { product: this.accountDetails, balance: this.balance, accountId: this.accountNumber, accountType: this.accountType, navToTab: 1 } }).catch(() => {})
    },
    goToTransactions () {
      this.$router.push({ name: 'AccountDetails', params: { product: this.accountDetails, balance: this.balance, accountId: this.accountNumber, accountType: this.accountType, navToTab: 0 } }).catch(() => {})
    },
    async getAccountsWithBalance () {
      if (this.allowInactiveAccountTransactionalOperations) this.excludeAccountStatus.splice(2, 1)
      const response = await preload.getAllCASAWithBalance(JSON.parse(sessionStorage.getItem('username')))
      if (response && response.length && !response.causes) {
        if (this.accountType === 'TXFR') {
          const filteredAccounts = response.filter((item) => {
            return !this.excludeARIStatusTXFR.includes(item.postingsRestriction) && !this.excludeAccountStatus.includes(item.accountStatus)
          })
          this.fetchSameAccounts(filteredAccounts)
        } else {
          const filteredAccounts = response.filter((item) => {
            return !this.excludeARIStatus.includes(item.postingsRestriction) && !this.excludeAccountStatus.includes(item.accountStatus)
          })
          this.fetchSameAccounts(filteredAccounts)
        }
      }
    },
    async getBeneficiaries () {
      const response = await commonService.getBeneficiaries(
        JSON.parse(sessionStorage.getItem('username'))
      )
      if (response && !response.causes) {
        this.beneficiaries = response.items
        const filterOtherAccounts = this.beneficiaries.filter((item) => {
          return !this.excludeARIStatus.includes(item.postingsRestriction) && !this.excludeAccountStatus.includes(item.accountStatus)
        })
        this.fetchOtherAccounts(filterOtherAccounts)
      }
    },
    fetchSameAccounts (accounts) {
      for (const item of accounts) {
        if (this.accountNumber !== item.accountId) {
          if ((this.accountType === 'SVGS' && this.allowedPayawayAccountTypeForSavingsClosure.includes(item.accountType)) ||
             (this.accountType === 'CACC' && this.allowedPayawayAccountTypeForCurrentClosure.includes(item.accountType)) ||
             (this.accountType === 'TXFR' && this.allowedPayawayAccTypeForFixedRateClosure.includes(item.accountType)) ||
             (this.accountType === 'TXEA' && this.allowedPayawayAccTypeForInstCashIsaClosure.includes(item.accountType))) {
            this.sameAccountsNOCR.push({
              ...item,
              primaryLine: formatPrimaryLine(item),
              secondaryLine: formatSecondaryLine(item),
              text: formatSelectedAccount(item),
              value: item.accountId
            })
          }
        }
      }
    },
    fetchOtherAccounts (accounts) {
      for (const item of accounts) {
        if (!this.nominatedAccountsConfig || item.ownAccount) {
          this.otherAccounts.push({
            ...item,
            primaryLine: item.name,
            secondaryLine: `${item.accountIdentification} - ${item.bankIdentifier}`,
            text: item.name,
            value: `${item.accountIdentification} - ${item.bankIdentifier}`
          })
        }
      }
    },
    changeAccountType () {
      this.selectedPayAwayAcc = ''
      this.setPayAwayAC()
    },
    setPayAwayAC (selectedValue) {
      if (this.selectedPayAwayAcc && this.selectedReasonForClosure && this.showCloseAccountReason) {
        this.enableNext = false
      } else if (this.selectedPayAwayAcc && !this.showCloseAccountReason) {
        this.enableNext = false
      } else this.enableNext = true
    },
    onNext () {
      if (this.accountType === 'TXFR') {
        if (this.enableOTPForFixedRateAccClosure) {
          this.showOTPScreen = true
          this.otpConfig.enabled = true
        } else {
          this.updateARI()
        }
      }
      if (this.accountType === 'TXEA') {
        if (this.enableOTP) {
          this.showOTPScreen = true
          this.otpConfig.enabled = true
        } else {
          this.closeSavingsAcc()
        }
      }
      if (this.accountType === 'CACC') {
        if (this.enableOTPForCurrentAccClosure) {
          this.showOTPScreen = true
          this.otpConfig.enabled = true
        } else {
          this.closeSavingsAcc()
        }
      }
      if (this.accountType === 'SVGS') {
        if (this.enableOTPForSavingsAccountClosure) {
          this.showOTPScreen = true
          this.otpConfig.enabled = true
        } else {
          this.closeSavingsAcc()
        }
      }
    },
    onProceed () {
      if (this.selectedPayAwayAcc) {
        this.enableConfirm = true
      }
    },
    goBack () {
      this.enableConfirm = false
    },
    dispatchError (content) {
      this.$store.dispatch('appStore/setAppData', {
        message: {
          title: 'Error',
          content,
          type: 'error',
          width: 400,
          persistent: true,
          close: true,
          component: 'dob-modal'
        }
      })
    },
    isServiceUnavailable (response) {
      const status = response?.data?.status || response?.status
      if (this.serviceNotAvailableStatusList.includes(status)) return true
      return false
    }
  },
  watch: {
    showOTPScreen () {
      if ((this.enableOTPForCloseAccount || this.enableOTPForSavingsAccountClosure || this.enableOTPForCurrentAccClosure) && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  },
  beforeDestroy () {
    event.$off('IS_OTP_VALID')
  }
}

</script>
